module.exports = __webpack_public_path__ + "img/icon_point.a5d7068d.svg";